export default "__VITE_ASSET__oOSxnl_z__"